module.exports = __webpack_public_path__ + "images/treasure-hunter-62458b79013aaca679cc11f8c3b846f6.png";